// Copyright (c) 2018 Deere & Company

import _ from 'lodash';

export const getSortByList = (availableColumns, selectedColumns) =>
    _.intersectionBy(availableColumns, selectedColumns, 'id');



// WEBPACK FOOTER //
// ./src/shared/services/get-excel-layout-modal-sort-by-list.js